// import React, { Fragment,useState,useContext}  from 'react'
// import MetaLayout, { Wrapper } from "../../../../components/UI/preReg/Layout.Metaverse";
// import { DynamicStyles } from "../Resources/GlobalStyle";
// import { AppContext } from "../../../../components/AppProvider";

// import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from "swiper";
// import { Swiper, SwiperSlide } from "swiper/react";

// import "swiper/swiper.scss";
// import "swiper/components/navigation/navigation.scss";
// import "swiper/components/pagination/pagination.scss";
// import "swiper/components/scrollbar/scrollbar.scss";

// import decsImg1 from "../../../../resources/images/metaverse/34.png";
// import decsImg2 from "../../../../resources/images/metaverse/35.png";
// import decsImg3 from "../../../../resources/images/metaverse/36.png";
// import decsImg4 from "../../../../resources/images/metaverse/37.png";
// import useStore from '../../../../modules/utils/store';

// SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

export default () => null;
// export default (props) => {
//   const { auth, iam } = useContext(AppContext);
//   const { siteInfo } = useStore();
//   const { history, match,closeModal } = props;
//   const eventIdx = match?.params.eventIdx;
  
//   return (
//     <Fragment>
//       <MetaLayout closeModal={closeModal}>
//         <Wrapper>
//           <InformationForm eventIdx={eventIdx}/>
//         </Wrapper>
//       </MetaLayout>
//       <DynamicStyles/>
//     </Fragment>
//   )
// }
// const InformationForm = (props) => { 
//   const eventIdx = props?.eventIdx;
//   const { siteInfo } = useStore();

//   return (
//     <div className="inform_wrap wid_1060">
//       <h1>INFORMATION</h1>
//       <div className="inform_wrap_inner">
//         <ul className="inform_tab_menu">
//           <li className="active"><span>사이트이용</span></li>
//         </ul>
//         <div className="inform_wrap_container">
//           <h2>
//             안녕하세요. 웨비나스 입니다.<br/>
//             서비스 이용에 관한 안내를 드리겠습니다.
//           </h2>

//           <div className="inform_wrap_container_content">
//             <img src={decsImg1 } />
//             <img src={decsImg2 } />
//             <img src={decsImg3 } />
//             <img src={decsImg4 } />
//           </div>
//           <div className="inform_wrap_container_text">
//             <h3>문의</h3>
//             <div>
//               <p>{siteInfo.cs} 담당 : {siteInfo.csCompanyName} {siteInfo.csMemberName}</p>
//               <p>등록관련 전화번호: {siteInfo.csRegTel}</p>
//               <p>접속관련 전화번호: {siteInfo.csAccessTel}</p>
//               <p>{siteInfo.csDescription}</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }